import Front from './Front.vue';
import Back from './Back.vue';

export {
    Front,
    Back
};
